"use strict";
// defined in Alaska at https://gitlab.eventops.io/athlinks/start/blob/master/Athlinks.ClassLib/library/Types/Status.cs
Object.defineProperty(exports, "__esModule", { value: true });
var EventStatus;
(function (EventStatus) {
    EventStatus[EventStatus["NotSet"] = -1] = "NotSet";
    EventStatus[EventStatus["Declined"] = 0] = "Declined";
    EventStatus[EventStatus["Approved"] = 1] = "Approved";
    EventStatus[EventStatus["Hidden"] = 2] = "Hidden";
    EventStatus[EventStatus["Rejected"] = 3] = "Rejected";
    EventStatus[EventStatus["Pending"] = 4] = "Pending";
    EventStatus[EventStatus["Merged"] = 5] = "Merged";
})(EventStatus = exports.EventStatus || (exports.EventStatus = {}));
//# sourceMappingURL=eventStatus.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-model/dist/common/eventStatus.js
 ** module id = 2093
 ** module chunks = 0
 **/